export interface IOrder {
  id: number;
  name: string;
  baseValue: number;
  vatValue: number;
  vatPercentage: number;
  total: number;
}

export interface IPaymentMethod {
  id: string;
  name: string;
  logoUrl: string;
}

export enum EOrderTypeId {
  INSERT_OFFER_FREE = 56,
  INSERT_OFFER_STANDARD = 57,
  INSERT_OFFER_VIP = 58,
  PREMIUM_ACC_6_MONTHS = 61,
  PREMIUM_ACC_12_MONTHS = 60,
  PREMIUM_ACC_UNLIMITED = 59,
  CREDIT_CHECK = 52,
  SELF_CHECK = 55,
  INSERT_OFFER_UKRAINE,
  CREDIT_CHECK_CZ = 77,
  CREDIT_CHECK_SK = 78,
  IMMENDIATE_PHONE = 79,
  CREDIT_CHECK_UA = 80,
}

export const getCreditCheckOrderTypeId = (
  countryCode: "CZ" | "SK" | "UA",
): EOrderTypeId => {
  switch (countryCode) {
    case "CZ":
      return EOrderTypeId.CREDIT_CHECK_CZ;
    case "SK":
      return EOrderTypeId.CREDIT_CHECK_SK;
    case "UA":
      return EOrderTypeId.CREDIT_CHECK_UA;
  }
};
